import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {select, Store} from '@ngrx/store';
import {IState} from '../store/root.reducer';
import {Observable} from 'rxjs';

@Injectable()
export class OecIntegrationConfigurationService {
  apiUrl = `${environment.oecIntegrationAPI}Configuration`;

  showAMElp: boolean;
  isDiscountOE: boolean;
  discountOeDisplayName: string;

  constructor(
    private httpClient: HttpClient,
    private store: Store<IState>) {
    this.store.pipe(select((state: IState) => state.currentUser)).subscribe(async (currentUser) => {
      if (currentUser.oecCompanyId) {
        await this.loadConfiguration();
      }
    });
  }

  get(): Observable<IOecConfiguration> {
    return this.httpClient.get<IOecConfiguration>(this.apiUrl);
  }

  async loadConfiguration(): Promise<any> {
    return new Promise((resolve) => {
      this.get().subscribe(x => {
        this.showAMElp = x.showAMElp ?? false;
        this.isDiscountOE = x.isDiscountOE ?? false;
        this.discountOeDisplayName = x.discountOeDisplayName;
        resolve(true);
      });
    });
  }
}

interface IOecConfiguration {
  showAMElp: boolean;
  isDiscountOE?: boolean;
  discountOeDisplayName?: string;
}


export function initConfiguration(
  configurationService: OecIntegrationConfigurationService
) {
  return async () => {
    await configurationService.loadConfiguration();
  };
}
